var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sc-ed99b3fd-0 jrAENr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#12100F",
    height: 48,
    rx: 8,
    width: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.462 20.783C29.5965 20.4425 32.6833 18.1276 32.6833 16.3234C32.6833 15.7787 32.2564 15.4043 31.6325 15.4043C30.4503 15.4043 28.4472 17.2425 27.462 20.783ZM17.5777 29.7361C14.7864 29.7361 14.5566 32.5957 17.3478 32.5957C18.5957 32.5957 20.1063 32.085 20.8944 31.1659C19.745 30.1446 18.7927 29.7361 17.5777 29.7361ZM35.3432 28.5106C35.5073 33.3106 33.1431 36 29.1368 36C26.7724 36 25.5903 35.0808 23.0617 33.3787C21.7482 34.8766 19.2525 36 17.1836 36C10.0577 36 10.3533 26.6383 17.6105 26.6383C19.1211 26.6383 20.4018 27.0468 22.0437 28.1021L23.1274 24.1872C18.6614 22.9276 16.4283 19.3872 18.6285 14.3149H22.1751C20.2048 17.6851 21.5511 20.4766 24.0468 20.783C25.3932 15.8468 28.283 12 32.1251 12C34.2924 12 36 13.4638 36 16.1191C36 20.3744 30.6145 23.8468 26.5425 24.1872L24.8678 30.2808C26.7724 32.5616 32.0594 34.7743 32.0594 28.5106H35.3432Z",
    fill: "#F5F1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeather);
export default __webpack_public_path__ + "static/media/Leather.eca818fb8be58d9040237c8a5addac2a.svg";
export { ForwardRef as ReactComponent };